import { Exclude, Expose } from "class-transformer";
import { IsDate, IsDefined, IsString, IsUUID, Length } from "class-validator";
import { v4 as uuid } from "uuid";

import { TransformToDate } from "../transformers/transformToDate";

@Exclude()
export class RideNote {
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public userId: string;

    @IsString()
    @IsDefined()
    @Length(0, 97)
    @Expose()
    public username: string;

    @IsString()
    @IsDefined()
    @Expose()
    public text: string;

    @IsDate()
    @IsDefined()
    @Expose()
    @TransformToDate
    public createdAt: Date = new Date();
}
